import styled from 'styled-components';

export const Wrap = styled.div`
  width: 100%;

  .adm-tabs-tab {
    font-size: 14px !important;
  }
`;

export const WrapTab = styled.div`
  overflow-y: scroll;
  ul {
    list-style: none;
    padding: 0px;
  }

  ::-webkit-scrollbar {
    width: 6px;
    background: transparent !important;
    display: none;
  }

  li {
    cursor: pointer;
    padding: 20px 12px;
    height: 25px;
    width: 100%;
    display: flex;
    align-items: center;
  }

  li:hover {
    background: #f1f1f1;
  }

  ul .active {
    color: ${p => p.theme.colors.primary.main};
    background-color: #e1e1e1;
  }

  ul {
    height: calc(100vh - 220px);
  }

  ul {
    display: flex;
    flex-direction: column;
  }

  ul button {
    background: #ffffff;
    border: none;
    text-align: start;
    padding: 20px 12px;
    height: 25px;
    width: 100%;
    display: flex;
    align-items: center;
  }

  ul button:hover {
    background: #f1f1f1;
  }
`;

export const WrapError = styled.div`
  padding-top: 5px;
  color: red;
`;

export const WrapInput = styled.div`
  width: 100%;
  padding: ${p => p.theme.app.padding.vertical};
`;

export const WrapInputFullAddress = styled.div`
  .adm-input-element {
    font-size: 14px !important;
    color: #8e8e8e;
    padding: 0px 5px;
  }
`;
